import { inject, Injectable, linkedSignal, signal } from '@angular/core';
import { StorageService } from '@shared/services/storage.service';
import { StorageKey } from '@shared/enums';
import { GuardianshipOverview } from '../interfaces/guardianship-overview.interface';

@Injectable({ providedIn: 'root' })
export class GuardianshipOverviewStateService {
  private readonly _storageService = inject(StorageService);

  private readonly _overview = signal<GuardianshipOverview | null>(
    this._storageService.read(StorageKey.guardianshipOverview) ?? null,
  );

  public readonly overview = this._overview.asReadonly();

  public setOverview(overview: GuardianshipOverview) {
    this._overview.set(overview);
  }
  private readonly _isLoading = signal(false);
  public readonly isLoading = this._isLoading.asReadonly();
  public setIsLoading(loading: boolean) {
    this._isLoading.set(loading);
  }

  private readonly _guardianshipId = linkedSignal(
    () => this.overview()?.id ?? null,
  );

  public readonly guardianshipId = this._guardianshipId.asReadonly();

  public setGuardianshipId(id: number | null) {
    this._guardianshipId.set(id);
  }
}
